// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle-chart__background[data-v-d5177f38]{stroke:#dee0eb}.circle-chart__circle[data-v-d5177f38]{-webkit-transform:rotate(-90deg);transform:rotate(-90deg);-webkit-transform-origin:center;transform-origin:center;stroke:#0bc15c}.circle-chart__info[data-v-d5177f38]{font-weight:500;font-size:14px}", ""]);
// Exports
module.exports = exports;
